// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__1YgMn","logo":"MainNavigation_logo__24LZs","counter":"MainNavigation_counter__MJtt6"};